import React, {useState} from "react";
import './ExpandableMenu.scss'
import  {ReactComponent as StationsIcon} from "../../assets/icons/stations.svg";
import  {ReactComponent as SettingsWheel} from "../../assets/icons/settingsWheel.svg";
import  {ReactComponent as SensorIcon} from "../../assets/icons/sensor.svg";

const ExpandableMenu = props => {

    const {menuTitle, children, menuType} = props;
    const [isExpanded, setIsExpanded] = useState(false)

    const expand = () => {
        const container = document.querySelector(`#content-${menuType}`);
        if(container.style.maxHeight) {
            setIsExpanded(false)
            container.style.maxHeight = null;
        } else {
            setIsExpanded(true)
            container.style.maxHeight = container.scrollHeight + "px";
        }
    }

    return (
        <div className="ExpandableMenu">
            <div className={isExpanded ? "collapsible collapsible--expanded" : "collapsible"} onClick={expand}>
                <div style={{display: 'flex'}}>
                    <div className='appNavItemIconHolder'>
                        {menuType === 'qrCodes' && (
                            <span className="material-icons appNavItemIcon">
                        qr_code_2
                    </span>
                        )}
                        {(menuType === 'stations') && (
                            <StationsIcon
                                className="stroke"
                            />
                        //     <span className="material-icons material-icons-outlined appNavItemIcon">
                        //                 sensors
                        // </span>
                        )}
                        {menuType === 'sensors' && (
                            <SensorIcon className="appNavItemIcon"/>
                        )}
                        {menuType === 'sensorSettings' && (
                            <SettingsWheel
                                className="fillStroke"
                            />
                        )}
                        {menuType === 'users' && (
                            <span className="material-icons material-icons-outlined appNavItemIcon">
                                manage_accounts
                            </span>
                        )}
                        {menuType === 'reports' && (
                            <span className="material-icons material-icons-outlined appNavItemIcon">
                                assessment
                            </span>
                        )}
                    </div>
                    <p>{menuTitle}
                    </p>
                </div>
                <span className='material-icons expandMenu'>
                    {isExpanded ? 'expand_less' : 'expand_more'}
                    </span>

            </div>
            <div id={`content-${menuType}`} className="content">
                {children}
            </div>
        </div>
    )
}

export default ExpandableMenu
